import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '@follosoft/react-components';

interface PayPayload {
  payment_method_id: string | number;
}

export function usePayService(message: string) {
  return useMutation<void, Error, PayPayload>({
    mutationFn: async (payload) => {
      await axiosInstance().post(`customer/service-call/${message}/pay`, payload);
    },
  });
}
